/* eslint-disable
    func-names,
    no-shadow,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['ViewModel', '$filter'];
const factory = function (ViewModel, $filter) {
  let UpcomingInvoiceVM;
  return (UpcomingInvoiceVM = class UpcomingInvoiceVM extends ViewModel {
    $listenTransformFn(data) {
      const newData = angular.copy(data);
      Object.keys(data).forEach(key => {
        if (data[key] instanceof Date) {
          return (newData[key] = $filter('date')(data[key], 'MM/dd/yyyy'));
        }
      });

      return newData;
    }
  });
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name];

module.exports = angular
  .module('bench.data.viewmodel.upcomingInvoice', moduleDeps)
  .factory('UpcomingInvoiceVM', factory);
